
import React from 'react';

const TeamSection: React.FC = () => {
  const teamMembers = [
    {
      name: 'Dr. Sarah Johnson',
      role: 'Chief Medical Officer',
      specialty: 'Cardiology',
      experience: '15 years',
      education: 'Harvard Medical School',
      image: 'https://public.readdy.ai/ai/img_res/f58396f56e623c1c74b27fc53a27becd.jpg'
    },
    {
      name: 'Dr. Michael Chen',
      role: 'Head of Surgery',
      specialty: 'Orthopedic Surgery',
      experience: '18 years',
      education: 'Johns Hopkins University',
      image: 'https://readdy.ai/api/search-image?query=Professional%20male%20surgeon%20in%20medical%20scrubs%2C%20experienced%20medical%20professional%2C%20hospital%20operating%20room%20background%2C%20surgical%20specialist%20portrait%2C%20confident%20healthcare%20provider%2C%20medical%20expertise&width=400&height=500&seq=doctor-michael&orientation=portrait'
    },
    {
      name: 'Dr. Emily Rodriguez',
      role: 'Director of Pediatrics',
      specialty: 'Pediatric Medicine',
      experience: '12 years',
      education: 'Stanford Medical School',
      image: 'https://readdy.ai/api/search-image?query=Professional%20female%20pediatrician%20in%20white%20coat%2C%20caring%20medical%20professional%2C%20pediatric%20clinic%20background%2C%20children%20healthcare%20specialist%2C%20warm%20and%20friendly%20demeanor%2C%20medical%20expertise%20with%20children&width=400&height=500&seq=doctor-emily&orientation=portrait'
    },
    {
      name: 'Dr. James Wilson',
      role: 'Emergency Medicine Chief',
      specialty: 'Emergency Medicine',
      experience: '20 years',
      education: 'Mayo Clinic College',
      image: 'https://readdy.ai/api/search-image?query=Professional%20male%20emergency%20doctor%20in%20medical%20uniform%2C%20experienced%20emergency%20medicine%20specialist%2C%20hospital%20emergency%20room%20background%2C%20urgent%20care%20professional%2C%20confident%20medical%20provider&width=400&height=500&seq=doctor-james&orientation=portrait'
    },
    {
      name: 'Dr. Lisa Thompson',
      role: 'Head of Radiology',
      specialty: 'Diagnostic Imaging',
      experience: '14 years',
      education: 'UCLA Medical Center',
      image: 'https://readdy.ai/api/search-image?query=Professional%20female%20radiologist%20in%20white%20coat%2C%20medical%20imaging%20specialist%2C%20modern%20radiology%20department%20background%2C%20diagnostic%20medicine%20expert%2C%20professional%20healthcare%20provider%20portrait&width=400&height=500&seq=doctor-lisa&orientation=portrait'
    },
    {
      name: 'Dr. Robert Kim',
      role: 'Neurology Department Head',
      specialty: 'Neurology',
      experience: '16 years',
      education: 'Columbia Medical School',
      image: 'https://readdy.ai/api/search-image?query=Professional%20male%20neurologist%20in%20white%20coat%2C%20brain%20specialist%20medical%20professional%2C%20neurology%20clinic%20background%2C%20neurological%20medicine%20expert%2C%20confident%20healthcare%20provider%2C%20medical%20expertise&width=400&height=500&seq=doctor-robert&orientation=portrait'
    }
  ];

  return (
    <section className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">Meet Our Expert Team</h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Our dedicated team of medical professionals brings decades of combined experience 
            and expertise to provide you with the highest quality healthcare.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {teamMembers.map((member, index) => (
            <div key={index} className="bg-white rounded-2xl shadow-lg overflow-hidden hover:shadow-xl transition-shadow duration-300">
              <div className="relative">
                <img 
                  src={member.image}
                  alt={member.name}
                  className="w-full h-80 object-cover object-top"
                />
                <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/60 to-transparent p-6">
                  <h3 className="text-xl font-bold text-white mb-1">{member.name}</h3>
                  <p className="text-teal-200 font-medium">{member.role}</p>
                </div>
              </div>
              
              <div className="p-6">
                <div className="space-y-3">
                  <div className="flex items-center space-x-3">
                    <div className="w-8 h-8 bg-teal-100 rounded-full flex items-center justify-center">
                      <i className="ri-stethoscope-line text-teal-600"></i>
                    </div>
                    <div>
                      <p className="text-sm text-gray-500">Specialty</p>
                      <p className="font-semibold text-gray-900">{member.specialty}</p>
                    </div>
                  </div>
                  
                  <div className="flex items-center space-x-3">
                    <div className="w-8 h-8 bg-blue-100 rounded-full flex items-center justify-center">
                      <i className="ri-time-line text-blue-600"></i>
                    </div>
                    <div>
                      <p className="text-sm text-gray-500">Experience</p>
                      <p className="font-semibold text-gray-900">{member.experience}</p>
                    </div>
                  </div>
                  
                  <div className="flex items-center space-x-3">
                    <div className="w-8 h-8 bg-green-100 rounded-full flex items-center justify-center">
                      <i className="ri-graduation-cap-line text-green-600"></i>
                    </div>
                    <div>
                      <p className="text-sm text-gray-500">Education</p>
                      <p className="font-semibold text-gray-900">{member.education}</p>
                    </div>
                  </div>
                </div>
                
                <button className="w-full mt-6 bg-teal-600 text-white py-3 rounded-lg font-semibold hover:bg-teal-700 transition-colors whitespace-nowrap cursor-pointer">
                  View Profile
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TeamSection;
